<ul class="dashletSiteacc__site-ul">
  @for (workspace of workspaceList; track trackByFunction(index, workspace); let index = $index) {
    @if (!workspace.blocked) {
      <pp-dashlet-timeline-single-workspace
        [ppLimitedWorkspaces]="ppLimitedWorkspaces"
        [ppWorkspace]="ppWorkspaces[workspace.workspaceId]"
        [ppSiteRange]="ppSiteRange"
        (ppToggleWorkspace)="toggleWorkspace($event)"
      ></pp-dashlet-timeline-single-workspace>
    }
    @if (workspace.blocked) {
      <li class="dashletSiteacc__site--disabled">
        <pp-checkbox [ppChecked]="false" [ppDisabled]="true"></pp-checkbox>
        <p class="dashletSiteacc__site-label">
          {{ ppWorkspaces[workspace.workspaceId]?.siteName }}
        </p>
      </li>
    }
  }
</ul>
